<div class="footer__bottom">
  <nav class="navigation">
    <div class="navigation__left trademark">
      <p class="trademark_item copyright">{{ 'footer.copyright' | translate }}</p>
    </div>
    <ol
      data-testid="footer-menu"
      shared-footer-menu
      class="navigation__center menu"></ol>
  </nav>
</div>
